import API from "APIs/base";
import { ENDPOINT } from "config/constants";

const locator_office_clear_count = async ({ userId, startDate, endDate }) => {
  const params = { userId, startDate, endDate };
  return await API.getMethod(
    `${ENDPOINT.officeClear.locatorOfficeClearCount}`,
    true,
    true,
    params
  );
};

export default {
  locator_office_clear_count,
};
